import { Icon } from "@iconify/react"

interface ReactIconProps {
    icon: string
    width?: string
    height?: string
    style?: React.CSSProperties
}

const CtyReactIcon = (props: ReactIconProps) => {
    const { icon, width, height, style } = props
    return (
        <Icon icon={icon} width={width} height={height} style={style} />
    )

}

export { CtyReactIcon }